import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { getApp } from 'ducks/apps'
import { expandAllLayers, collapseAllLayers } from 'ducks/editor/layers'
import Params from 'components/Editor/Params'
import InspectPanel from 'components/Editor/Inspect'
import { PanelItem } from 'components/Shared/Panel'
import Layers from 'components/Editor/Layers'
import ScreenDeepLinking from 'components/Editor/ScreenDeepLinking'
import DeepLinkingNA from 'components/Editor/DeepLinking/DeepLinkingNA'

import ScreenAction from '../ScreenAction'
import ScreenTemplateCollapsible from './ScreenTemplateCollapsible'

import './ScreenControl.css'

const ScreenControl = props => {
  const {
    screenTemplateExpanded,
    appId,
    object,
    onCollapseScreenTemplate,
    onShowScreenTemplates,
  } = props
  const dispatch = useDispatch()
  const app = useSelector(state => getApp(state, appId))
  const isLegacyApp = !app?.magicLayout
  const { id } = object
  const GROUP = `${id}-screen`

  const handleExpandAll = e => {
    e.stopPropagation()
    dispatch(expandAllLayers())
  }

  const handleCollapseAll = e => {
    e.stopPropagation()
    dispatch(collapseAllLayers())
  }

  return (
    <>
      <ScreenTemplateCollapsible
        expanded={screenTemplateExpanded}
        appId={appId}
        object={object}
        onClose={onCollapseScreenTemplate}
        onExpand={onShowScreenTemplates}
      />
      <PanelItem
        title="Components"
        group={GROUP}
        fluid
        defaultExpanded
        renderActions={() => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '2px',
            }}
          >
            <span
              onClick={handleExpandAll}
              className="screen-control-button"
              data-adalo-id="expand-all"
            >
              Expand All
            </span>
            <span className="screen-control-button-separator">|</span>
            <span
              className="screen-control-button"
              data-adalo-id="collapse-all"
              onClick={handleCollapseAll}
            >
              Collapse All
            </span>
          </div>
        )}
      >
        <Layers objectId={id} />
      </PanelItem>
      <PanelItem title="Actions" group={GROUP} fluid>
        <ScreenAction object={object} />
      </PanelItem>
      <PanelItem title="Available Data" group={GROUP} fluid>
        <Params component={object} />
      </PanelItem>
      <PanelItem title="Deep Linking" group={GROUP} fluid>
        {isLegacyApp ? (
          <DeepLinkingNA />
        ) : (
          <ScreenDeepLinking component={object} />
        )}
      </PanelItem>
      <InspectPanel />
    </>
  )
}

ScreenControl.propTypes = {
  screenTemplateExpanded: PropTypes.bool.isRequired,
  appId: PropTypes.string.isRequired,
  object: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCollapseScreenTemplate: PropTypes.func.isRequired,
  onShowScreenTemplates: PropTypes.func.isRequired,
}

export default ScreenControl
